module.exports = __webpack_public_path__ + "static/media/IMG_0356.5c1df3a6.jpg";